import React, { useState } from 'react'
import { Modal } from './modal'
import { ActiveView } from '../active-view'
import { classNames as cn } from '../../../../utils/class-names'
import styles from './trigger.module.css'

export const TriggerCashoutModal = () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <Modal showModal={showModal} onClose={() => setShowModal(false)} title="Solicitar Retiro">
        <ActiveView />
      </Modal>

      <div className={styles.buttonContainer}>
        <button onClick={() => setShowModal(true)} className={cn('payment-button')}>Solicitar Retiro</button>
      </div>
    </>
  )
}
